import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import { isTrackingParcel } from '@/parcels/helpers/helpers'
import parcelServices from '@/parcels/services/services'

const useResetParcel = ({ storeId, relatedId, refetchParcel, parcel, setToastInfo }) => {
  const { fetchData, loading: resettingParcel } = useFetch(() => parcelServices.resetParcel({ storeId, relatedId }), {
    doInitialRequest: false,
  })

  const [showResetParcelModal, setShowResetParcelModal] = useState(false)

  const openResetParcelModal = () => {
    setShowResetParcelModal(true)
  }

  const closeResetParcelModal = () => {
    setShowResetParcelModal(false)
  }

  const onResetParcel = async () => {
    try {
      await fetchData()
      await refetchParcel()
      setShowResetParcelModal(false)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const allowResetParcel =
    !isTrackingParcel(parcel) && [shipmentStatuses.packed, shipmentStatuses.ready].includes(parcel?.status)

  return {
    showResetParcelModal,
    openResetParcelModal,
    closeResetParcelModal,
    onResetParcel,
    resettingParcel,
    allowResetParcel,
  }
}

export default useResetParcel
